<template>
  <div
    class="inner"
    :class="{ swiping: isSwiping }"
    :style="{ transform: `translateY(${translateY}px)` }"
  >
    <SwipeWrapper
      @pan-start="handleSwipeDownStart"
      @pan-move="handleSwipeMove"
      @pan-end="handleSwipeDownEnd"
    >
      <div class="swipe"></div>
    </SwipeWrapper>
    <h2>Время работы</h2>
    <div class="value working-hours">
      <div
        v-for="(day, index) in props.workingTime"
        :key="index"
        class="working-hours-row"
      >
        <div class="working-hours-label">
          {{
            day.workShiftStart.weekday === day.workShiftEnd.weekday
              ? getRussianWeekdayFull(day.workShiftStart.weekday)
              : `${getRussianWeekday(
                  day.workShiftStart.weekday
                )} - ${getRussianWeekday(day.workShiftEnd.weekday)}`
          }}
        </div>
        <div class="working-hours">
          {{ getTime(day.workShiftStart.time) }} &nbsp;—&nbsp;
          {{ getTime(day.workShiftEnd.time) }}
        </div>
      </div>
    </div>
    <IconPopupCross
      v-if="screenWidth !== 'mobile'"
      class="modal-cross"
      @click="closeModal"
    />
  </div>
</template>

<script setup>
import { computed, defineProps, ref } from "vue";
import { useStore } from "vuex";
import IconPopupCross from "@/components/icons/IconPopupCross.vue";
import SwipeWrapper from "@/components/ui/SwipeWrapper.vue";
import { convertFromNumberToTime } from "@/assets/js/utils/helpers";
import {
  WEEKDAYS_RUSSIAN,
  WEEKDAYS_RUSSIAN_FULL,
} from "@/assets/js/utils/consts";

const props = defineProps({
  workingTime: Array,
});

const store = useStore();

const isSwiping = ref(false);
const translateY = ref(0);
const threshold = ref(100);

const screenWidth = computed(() => {
  return store.getters.screenType;
});

const closeModal = () => {
  store.dispatch("closeModal");
};

function getTime(val) {
  return convertFromNumberToTime(val).join(":");
}

function getRussianWeekday(value) {
  return WEEKDAYS_RUSSIAN[value];
}

function getRussianWeekdayFull(value) {
  return WEEKDAYS_RUSSIAN_FULL[value];
}

const handleSwipeDownStart = () => {
  isSwiping.value = true;
};

const handleSwipeDownEnd = () => {
  if (translateY.value > threshold.value) {
    closeModal();
  } else {
    translateY.value = 0;
    isSwiping.value = false;
  }
};

const handleSwipeMove = (event) => {
  if (event.deltaY > 0) {
    translateY.value = event.deltaY;
  }
};
</script>

<style lang="scss" scoped>
.inner {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 448px;
  margin: auto;
  padding: 32px 56px 40px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.08);
  transition: all 0.3s ease;

  @media screen and (max-width: 841px) {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    max-width: 100%;
    box-shadow: 0 -2px 10px 0 #0000000d;
    border-radius: 20px 20px 0 0;
    padding: 24px 16px 24px 16px;
  }

  &.swiping {
    transition: none;
  }
}

h2 {
  margin-bottom: 24px;
  text-align: center;
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  color: #f0811e;
}

p {
  width: 100%;
  font-weight: 400;
  font-size: 16px;
  line-height: 22px;
  text-align: center;
  color: #222222;
}

.buttons {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  margin-top: 32px;
}

.button {
  width: 100%;

  &:last-child {
    margin-top: 16px;
  }
}

.modal-cross {
  position: absolute;
  top: 25px;
  right: 25px;
  cursor: pointer;
}

.swipe {
  display: none;

  @include mobile {
    display: block;
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    border-radius: 16px 16px 0 0;
    background-color: #ffffff;

    &::before {
      content: "";
      left: 50%;
      position: absolute;
      top: 6px;
      transform: translate(-50%);
      width: 36px;
      height: 6px;
      border-radius: 4px;
      background-color: #d6d6d6;
    }
  }
}

.value {
  width: 328px;
  margin: 0 auto;
}

.working-hours {
  display: flex;
  flex-direction: column;
  align-items: initial;
  flex-wrap: wrap;
  gap: 4px;

  font-size: 16px;
  line-height: 22px;
  font-weight: 400;
  text-align: left;

  &-row {
    display: flex;
    justify-content: space-between;
  }

  &-label {
    margin-right: 4px;
    font-weight: 600;
  }
}
</style>
